var _path, _path2, _path3, _path4, _path5, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEasyProxyMob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 443,
    height: 950,
    viewBox: "0 0 443 950",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M423.6 902C424.925 902 426 903.075 426 904.4V915.6C426 916.925 424.925 918 423.6 918H406.298C405.661 918 405.051 918.253 404.601 918.703L404.303 919.001C403.853 919.451 403.6 920.061 403.6 920.698V930.909C403.6 931.545 403.853 932.156 404.303 932.606L404.994 933.297C405.444 933.747 406.055 934 406.691 934H423.6C424.925 934 426 935.075 426 936.4V947.6C426 948.925 424.925 950 423.6 950H406C404.675 950 403.6 948.925 403.6 947.6V936.214C403.6 935.627 403.367 935.064 402.951 934.649C402.536 934.233 401.973 934 401.386 934H380.4C379.075 934 378 932.925 378 931.6V920.4C378 919.075 379.075 918 380.4 918L400.915 918C401.552 918 402.162 917.747 402.612 917.297L402.897 917.012C403.347 916.562 403.6 915.952 403.6 915.315V904.4C403.6 903.075 404.675 902 406 902H423.6Z",
    fill: "url(#paint0_linear_32_153)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M411.623 769.623C412.022 769.224 412.564 769 413.128 769H429.696C430.969 769 432 767.968 432 766.695V750.305C432 749.032 430.969 748 429.696 748H413.305C412.032 748 411 749.032 411 750.305V766.507C411 767.119 410.758 767.705 410.325 768.137L410.137 768.325C409.705 768.757 409.119 769 408.508 769H392.305C391.032 769 390 770.032 390 771.305V787.695C390 788.968 391.032 790 392.305 790H408.695C409.968 790 411 788.968 411 787.695V771.128C411 770.564 411.224 770.022 411.623 769.623Z",
    fill: "url(#paint1_linear_32_153)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2444 736.809C54.7932 737.358 55.5377 737.667 56.3139 737.667H77.0725C78.6889 737.667 79.9993 738.977 79.9993 740.594V761.407C79.9993 763.023 78.689 764.333 77.0725 764.333L56.0362 764.333C55.3195 764.333 54.6322 764.618 54.1254 765.125C53.6186 765.632 53.3339 766.319 53.3339 767.036V788.073C53.3339 789.69 52.0236 791 50.4071 791H29.5941C27.9777 791 26.6673 789.69 26.6673 788.073V767.314C26.6673 766.538 26.3589 765.794 25.81 765.245L25.7559 765.191C25.2071 764.642 24.4626 764.333 23.6864 764.333H2.92683C1.31039 764.333 0 763.023 0 761.407V740.594C0 738.977 1.31039 737.667 2.92683 737.667H23.5018C24.2781 737.667 25.0225 737.358 25.5714 736.809L25.81 736.571C26.3589 736.022 26.6673 735.277 26.6673 734.501V713.927C26.6673 712.31 27.9777 711 29.5941 711H50.4071C52.0236 711 53.3339 712.31 53.3339 713.927V734.687C53.3339 735.463 53.6423 736.207 54.1912 736.756L54.2444 736.809ZM52.4233 738.524C51.8744 737.975 51.1299 737.667 50.3537 737.667H29.3691C28.6524 737.667 27.965 737.951 27.4582 738.458C26.9514 738.965 26.6667 739.652 26.6667 740.369V761.353C26.6667 762.13 26.975 762.874 27.5239 763.423L27.577 763.476C28.1259 764.025 28.8703 764.333 29.6466 764.333L50.169 764.333C50.9452 764.333 51.6897 764.025 52.2386 763.476L52.4754 763.239C53.0243 762.69 53.3327 761.946 53.3327 761.17V740.646C53.3327 739.869 53.0243 739.125 52.4754 738.576L52.4233 738.524Z",
    fill: "url(#paint2_linear_32_153)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.2623 37.4779C65.9283 37.8119 65.4752 37.9996 65.0028 37.9996L11.7812 37.9996C10.7975 37.9996 10 38.7971 10 39.7808L10 55.2183C10 56.2021 10.7975 56.9996 11.7812 56.9996L64.8708 56.9996C65.3432 56.9996 65.7963 57.1873 66.1303 57.5213L66.4785 57.8694C66.8125 58.2035 67.0002 58.6566 67.0002 59.129L67.0002 74.003C67.0002 74.4755 66.8125 74.9285 66.4785 75.2626L66.2628 75.4783C65.9287 75.8123 65.4756 76 65.0032 76L49.7815 76C48.7978 76 48.0003 76.7975 48.0003 77.7813L48.0003 93.2187C48.0003 94.2025 48.7978 95 49.7815 95L65.2189 95C66.2027 95 67.0002 94.2025 67.0002 93.2187L67.0002 77.9977C67.0002 77.5253 67.1878 77.0723 67.5219 76.7382L67.7384 76.5217C68.0724 76.1877 68.5255 76 68.9979 76L84.2188 76C85.2026 76 86.0001 75.2025 86.0001 74.2188L86.0001 58.9978C86.0001 58.5253 86.1878 58.0723 86.5218 57.7382L86.7383 57.5217C87.0723 57.1877 87.5254 57 87.9978 57L103.219 57C104.203 57 105 56.2025 105 55.2188L105 39.7813C105 38.7975 104.203 38 103.219 38L87.8658 38C87.3934 38 86.9403 37.8124 86.6063 37.4783L86.5214 37.3934C86.1873 37.0593 85.9997 36.6063 85.9997 36.1339L85.9997 20.7809C85.9997 19.7971 85.2022 18.9996 84.2184 18.9996L68.8655 18.9996C68.3931 18.9996 67.94 18.8119 67.6059 18.4779L67.5218 18.3938C67.1878 18.0597 67.0001 17.6067 67.0001 17.1343L67.0001 1.78126C67.0001 0.797501 66.2026 8.51057e-06 65.2189 8.55357e-06L49.7815 9.22836e-06C48.7977 9.27136e-06 48.0002 0.797502 48.0002 1.78126L48.0002 17.2188C48.0002 18.2025 48.7977 19 49.7815 19L64.8712 19C65.3436 19 65.7967 19.1877 66.1307 19.5217L66.478 19.869C66.8121 20.2031 66.9997 20.6562 66.9997 21.1286L66.9997 36.0026C66.9997 36.4751 66.8121 36.9281 66.478 37.2622L66.2623 37.4779ZM67.5215 38.7378C67.1874 39.0719 66.9997 39.5249 66.9997 39.9973L66.9997 55.1338C66.9997 55.6063 67.1874 56.0593 67.5215 56.3934L67.6064 56.4783C67.9404 56.8124 68.3935 57 68.8659 57L84.0031 57C84.4756 57 84.9286 56.8124 85.2627 56.4783L85.4784 56.2626C85.8124 55.9285 86.0001 55.4755 86.0001 55.0031L86.0001 40.129C86.0001 39.6566 85.8124 39.2035 85.4784 38.8695L85.1302 38.5213C84.7962 38.1873 84.3431 37.9996 83.8707 37.9996L68.9975 37.9996C68.5251 37.9996 68.072 38.1873 67.738 38.5213L67.5215 38.7378Z",
    fill: "url(#paint3_linear_32_153)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M386.2 11C388.851 11 391 13.149 391 15.8V38.2C391 40.851 388.851 43 386.2 43H363.8C361.149 43 359 40.851 359 38.2L359 15.8C359 13.149 361.149 11 363.8 11L386.2 11Z",
    fill: "url(#paint4_linear_32_153)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.5 408L409.605 408C410.506 408 411.369 407.642 412.006 407.006C412.642 406.369 413 405.506 413 404.605L413 382.5C413 380.015 415.015 378 417.5 378H438.5C440.985 378 443 380.015 443 382.5V403.5C443 405.985 440.985 408 438.5 408H416.395C415.495 408 414.631 408.358 413.994 408.994C413.358 409.631 413 410.495 413 411.395V433.5C413 435.985 410.985 438 408.5 438H327.5C325.015 438 323 435.985 323 433.5L323 412.5C323 410.015 325.015 408 327.5 408Z",
    fill: "url(#paint5_linear_32_153)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.5 348C355.015 348 353 350.015 353 352.5L353 373.5C353 375.985 355.015 378 357.5 378L408.5 378C410.985 378 413 375.985 413 373.5V351.395C413 350.495 413.358 349.631 413.994 348.994C414.631 348.358 415.495 348 416.395 348H438.5C440.985 348 443 345.985 443 343.5V322.5C443 320.015 440.985 318 438.5 318L417.5 318C415.015 318 413 320.015 413 322.5V344.605C413 345.506 412.642 346.369 412.006 347.006C411.369 347.642 410.506 348 409.605 348L357.5 348Z",
    fill: "url(#paint6_linear_32_153)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32_153",
    x1: 402,
    y1: 902,
    x2: 402,
    y2: 950,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_32_153",
    x1: 411,
    y1: 748,
    x2: 411,
    y2: 790,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_32_153",
    x1: 39.9997,
    y1: 711,
    x2: 39.9997,
    y2: 791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_32_153",
    x1: 9.99999,
    y1: 47.5,
    x2: 105,
    y2: 47.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_32_153",
    x1: 375,
    y1: 11,
    x2: 375,
    y2: 43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_32_153",
    x1: 383,
    y1: 318,
    x2: 383,
    y2: 438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_32_153",
    x1: 383,
    y1: 318,
    x2: 383,
    y2: 438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasyProxyMob);
export default __webpack_public_path__ + "static/media/EasyProxyMob.8db37e96aa608dad8d2a8271d0a51352.svg";
export { ForwardRef as ReactComponent };